import useMintRequests3Step from '@hooks/queries/registry/mint/useMintRequests';
import useRegistrarService from '@hooks/queries/registry/onboarding/useRegistrarService';
import { useParties } from '../../contexts/PartiesContext';

export const useInboundMintRequests = () => {
  const { party } = useParties();
  const registrarService = useRegistrarService();
  const isRegistrar = !!registrarService.data;

  const requests = useMintRequests3Step();
  const filtered = requests.data?.filter((d) => d.payload.mint.registrar === party);

  if (!isRegistrar) {
    return [];
  }
  return filtered || [];
};
